export type * from './types';

import * as enums from './types/enums';
import ConnectyCube from './ConnectyCube';

export default Object.assign(new ConnectyCube(), { ConnectyCube, ...enums });
